<template>
    <!-- top title (s) -->
    <section class="pu_locationSection">
        <h2>{{ this.getBase.adminMenuName_3d }}</h2>
        <div>
            <ul class="pu_location">
                <li><a href="javascript:;"><i class="xi-home">홈</i></a></li>
                <li v-html="this.getBase.adminMenuName_1d"></li>
                <li v-html="this.getBase.adminMenuName_2d"></li>
                <li v-html="this.getBase.adminMenuName_3d"></li>
            </ul>
            <div class="pu_logout">
                <a href="javascript:;" v-on:click="logOut()" title="로그아웃" style="padding: 7px; line-height: 0; border-radius:9px; display: table; ">
                    <i class="xi-log-out" style="vertical-align:middle;"></i>
                    <span>로그아웃</span>
                </a>
            </div>
        </div>
    </section>
    <!-- top title (e) -->
</template>

<script>
    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase",
            }),

        }

        , data() {
            return {
                gubunPage: "INC ZADMIN TITLE"
            };
        },

        methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , default() {
            }

            // 저장
            , logOut: function () {

                if (confirm("로그아웃 하시겠습니까?")) {

                    // API 조회
                    this.$SendPost("/vue_api/zadmin/logout", {}, this.logOutReturn);
                }
            }

            // 저장 데이터
            , logOutReturn: function (data, err) {
                this.$PageMove("/zadmin");
            }

        },

        beforeCreate() {
            // this.$PrintLog(this.gubunPage + " : beforeCreate");
        },

        created() {
            // this.$PrintLog(this.gubunPage + " : created");
        },

        beforeMount() {
            // this.$PrintLog(this.gubunPage + " : beforeMount");
        },

        mounted() {
            this.$PrintLog(this.gubunPage + " : mounted");
            this.default();
        },

        beforeUpdate() {
            // this.$PrintLog(this.gubunPage + " : beforeUpdate");
        },

        updated() {
            // this.$PrintLog(this.gubunPage + " : updated");
        },

        beforeDestroy() {
            // this.$PrintLog(this.gubunPage + " : beforeDestroy");
        },

        destroyed() {
            // this.$PrintLog(this.gubunPage + " : destroyed");
        },
    };
</script>
